export default {"src":"/stays/_next/static/media/guests.897d09cb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};